import { render, staticRenderFns } from "./reporteUcsis.vue?vue&type=template&id=9ede81b0"
import script from "./reporteUcsis.vue?vue&type=script&lang=js"
export * from "./reporteUcsis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports